// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMBreadcrumb.tsx — PropelMapper breadcrumb trail.
// Ancestor links + chevron separators; the last item is the current page
// (bold, non-link). All --pm-* tokens.

const PMCRUMB_CSS = `
.pmcrumb{display:flex;align-items:center;gap:8px;flex-wrap:wrap;font:var(--pm-label-l);font-weight:600;color:var(--pm-fg-2);font-family:var(--pm-font-sans)}
.pmcrumb-link{color:var(--pm-fg-2);text-decoration:none;background:none;border:none;font:inherit;cursor:pointer;padding:0;border-radius:4px}
.pmcrumb-link:hover{color:var(--pm-primary)}
.pmcrumb-link:focus-visible{outline:none;box-shadow:var(--pm-focus-ring)}
.pmcrumb-sep{display:inline-flex;color:var(--pm-fg-3)}
.pmcrumb-sep svg{width:16px;height:16px;display:block}
.pmcrumb-current{color:var(--pm-fg-1);font-weight:700}
`;
function pmcrumbEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmcrumb-css")) return;
  const s = document.createElement("style"); s.id = "pmcrumb-css"; s.textContent = PMCRUMB_CSS;
  document.head.appendChild(s);
}
export function PMBreadcrumb({ items = [], onNavigate, className = "", style = {}, ...rest }) {
  pmcrumbEnsureCSS();
  const sep = (
    <span className="pmcrumb-sep" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
    </span>
  );
  return (
    <nav className={"pmcrumb" + (className ? " " + className : "")} aria-label="Breadcrumb" style={style} {...rest}>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <React.Fragment key={i}>
            {last
              ? <span className="pmcrumb-current" aria-current="page">{it.label}</span>
              : it.href
                ? <a className="pmcrumb-link" href={it.href} onClick={onNavigate ? (e) => { e.preventDefault(); onNavigate(it, i); } : undefined}>{it.label}</a>
                : <button type="button" className="pmcrumb-link" onClick={() => onNavigate && onNavigate(it, i)}>{it.label}</button>}
            {last ? null : sep}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
